import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ActionTooltip' })({
    tooltip: {
        background: '#151515',
        borderRadius: 20,
        padding: '20px 12px 12px 12px',
        maxWidth: 280,
        boxSizing: 'border-box'
    },
    arrow: {
        color: '#151515'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    description: {
        margin: 0,
        color: '#AFAFAF',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '140%',
        ['& strong']: {
            fontWeight: 700,
            color: '#FFF'
        }
    },
    button: {
        padding: '14px 16px',
        borderRadius: 12,
        background: '#F8F8F8 !important',
        color: '#232323',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        boxSizing: 'border-box'
    }
});
